
import { Validatable } from "../mixins/validatable";

export default Validatable.extend({
	data() {
		return {
			textValue: "00:00"
		};
	},
	props: {
		value: {
			type: Date as any as () => Date,
			default() {
				return new Date();
			}
		},
		label: String,
		fancy: Boolean,
		hasError: Boolean,
		step: Number
	},
	watch: {
		value: {
			immediate: true,
			handler(val:Date) {
				let hours = val.getHours().toFixed(0);
				let minutes = val.getMinutes().toFixed(0);
				if (hours.length == 1) {
					hours = `0${hours}`;
				}
				if (minutes.length == 1) {
					minutes = `0${minutes}`;
				}
				let text = `${hours}:${minutes}`;
				if (text != this.textValue) {
					this.textValue = text;
				}
			}
		},
		textValue(val:string) {
			let [hours, minutes] = val.split(":");
			let valHours = this.value.getHours();
			let valMinutes = this.value.getMinutes();
			let value = `${valHours}:${valMinutes}`;
			if (value != val) {
				let date = new Date(0);
				date.setHours(parseInt(hours) || 0);
				date.setMinutes(parseInt(minutes) || 0);
				this.$emit("input", date);
			}

		},
	},
	computed: {
		input():any {
			return this.$refs.input;
		}
	},
	methods: {
		focus() {
			this.input.focus();
		},
		onBlur(event: FocusEvent) {
			this.$emit("blur", event);
		}
	}
});
